
import { HttpClient } from  '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ItemEvaluation } from '../models/item-evaluation.model';
import { ResultRowModel } from '../models/result-table-row.model';
import { HpDataProviderService } from './hp-data-provider.service';

@Injectable({
  providedIn: 'root'
})
export class ResultsService {
  private http = inject(HttpClient);
  private hpProviderService = inject(HpDataProviderService);


  public upsertFinalEvaluation(evaluation: ItemEvaluation) {
    return this.http.post<any>(`${environment.API_URL}/evaluation/final`, { evaluation });
  }

  public getResults(isCurrentSituation: boolean) {
    const hpId = this.hpProviderService.getHp()?.hpId;
    if(hpId === undefined) {
      throw new Error('Hp is undefined'); 
    }
    const params = {isCurrentSituation};
    return this.http.get<ResultRowModel[]>(`${environment.API_URL}/results/table/${hpId}`, { params });
  }
}
